import { render } from "./Sidebars.vue?vue&type=template&id=987ccdf6"
import script from "./Sidebars.vue?vue&type=script&lang=js"
export * from "./Sidebars.vue?vue&type=script&lang=js"

import "./Sidebars.vue?vue&type=style&index=0&id=987ccdf6&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__